import { render, staticRenderFns } from "./QuantitySelector.vue?vue&type=template&id=1127276f&scoped=true&"
import script from "./QuantitySelector.vue?vue&type=script&lang=js&"
export * from "./QuantitySelector.vue?vue&type=script&lang=js&"
import style0 from "./QuantitySelector.vue?vue&type=style&index=0&id=1127276f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127276f",
  null
  
)

export default component.exports